import { InstrumentShell } from "../components/InstrumentShell";
import { KeyboardMappingPanel } from "../components/KeyboardMappingPanel";
import { SoundDnaPanel } from "../components/SoundDnaPanel";
import { useI18n } from "../i18n/LocaleContext";
import { getRecommendedOrientation } from "../mobile/MobileOrientationManager";
import { MobileGesturePad } from "../mobile/MobileGesturePad";
import { MobileInstrumentDrawer } from "../mobile/MobileInstrumentDrawer";
import { MobilePerformanceToolbar } from "../mobile/MobilePerformanceToolbar";
import type { InstrumentLayoutProps } from "./layoutTypes";

export function MobileInstrumentLayout(props: InstrumentLayoutProps) {
  const { t } = useI18n();
  const recommended = getRecommendedOrientation(props.instrument.id);
  const isRecommended = recommended === props.orientation;

  return (
    <div
      className={`play-layout mobile-instrument-layout is-${props.orientation}`}
      data-testid="mobile-instrument-layout"
      data-orientation={props.orientation}
    >
      <div className="mobile-orientation-row">
        <span
          className={`orientation-badge ${isRecommended ? "is-good" : "is-suggestion"}`}
          data-testid="orientation-badge"
        >
          {props.orientation} {t.play.orientationActive} / {recommended} {t.play.orientationRecommended}
        </span>
      </div>
      <div className="play-main mobile-play-main">
        <InstrumentShell
          instrument={props.instrument}
          variant={props.variant}
          tuning={props.tuning}
          activeNotes={props.activeNotes}
          onNoteStart={props.onNoteStart}
          onNoteEnd={props.onNoteEnd}
          onControl={props.onControl}
        />
        {props.audioError ? (
          <p className="status-message error-badge" role="alert">
            {props.audioError}
          </p>
        ) : null}
      </div>
      <MobileGesturePad
        instrument={props.instrument}
        onNoteStart={props.onNoteStart}
        onNoteEnd={props.onNoteEnd}
        onControl={props.onControl}
      />
      <MobilePerformanceToolbar
        instrument={props.instrument}
        onControl={props.onControl}
        onNoteStart={props.onNoteStart}
        onNoteEnd={props.onNoteEnd}
      />
      <MobileInstrumentDrawer title={t.play.mobileDrawerTitle}>
        <SoundDnaPanel instrument={props.instrument} testIdPrefix="mobile" />
        <KeyboardMappingPanel instrument={props.instrument} pressedKeys={props.pressedKeys} compact />
      </MobileInstrumentDrawer>
    </div>
  );
}
